import {
    fileUploadCompleted,
    fileUploadStarted,
    fileUploadProgress,
    fileUploadFailed,
    getFileFailed,
    fileUploadCleared,
} from "../actions";
import { StoreState } from "../../models/states/StoreState";
import { ThunkActionType } from "../actions/types";
import { makeAxios } from "./validation";

export function uploadFile(
    variableName: string,
    matrix: number,
    file: File,
): ThunkActionType<Promise<void>> {
    return async (dispatch, getState) => {
        const state: StoreState = getState();
        if (state.interview.respondent.simulated) {
            dispatch(fileUploadCompleted(variableName, matrix));
            return;
        }
        const data = new FormData();
        data.append("variableName", variableName);
        data.append("matrix", String(matrix));
        data.append("file", file);
        dispatch(fileUploadStarted(variableName, matrix, file.name, file.size));
        try {
            const result = await dispatch(makeAxios()).post("f/Upload", data, {
                onUploadProgress: (pe: ProgressEvent) => {
                    if (pe.lengthComputable)
                        dispatch(fileUploadProgress(variableName, matrix, pe.loaded / pe.total));
                },
            });
            if (result.status !== 200) throw new Error(`Unexpected status ${result.status}`);
            dispatch(fileUploadCompleted(variableName, matrix));
        } catch (err) {
            dispatch(fileUploadFailed(variableName, matrix, file.name, err));
        }
    };
}

export function getFile(
    variableName: string,
    fileName: string,
    mimType: string,
    matrix = 0,
): ThunkActionType<Promise<any>> {
    return async (dispatch, getState) => {
        try {
            const state: StoreState = getState();
            if (state.interview.respondent.simulated) return null;
            const result = await dispatch(makeAxios()).get("f/GetFile", {
                params: { variableName, fileName, matrix },
                responseType: "blob",
            });
            if (result.status !== 200) throw new Error(`Unexpected status ${result.status}`);
            if (result.data.type !== mimType) throw new Error(`File not found ${fileName}`);
            return result.data;
        } catch (err) {
            dispatch(getFileFailed(variableName, fileName, err));
            return null;
        }
    };
}

export function clearFile(variableName: string, matrix: number): ThunkActionType<Promise<void>> {
    return async (dispatch, getState) => {
        try {
            const state: StoreState = getState();
            if (state.interview.respondent.simulated) return;
            const result = await dispatch(makeAxios()).delete("f/delete", {
                params: { variableName, matrix },
            });
            if (result.status !== 200) throw new Error(`Unexpected status ${result.status}`);
            dispatch(fileUploadCleared(variableName, matrix));
        } catch (err) {
            console.log(err);
        }
    };
}
